import { Button, CircularProgress, Divider, Grid, Paper, Typography } from '@material-ui/core';
import React, { useEffect } from 'react';
import Chart from "react-google-charts";
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { useAppSelector } from '../../app/hooks';
import { getProjectDetails, getFanDetails, getFanData, getFetching, getFetchingError, createNewProject, getDrafts, getProjects } from '../../app/reducer/project.reducer';
import { ENCON_LOGO } from '../../assets';
import CampbellDiagram from '../charts/CampbellDiagram';
import OctaveBand from '../charts/OctaveBand';
import TorqueCurve from '../charts/TorqueCurve';
import { getUser } from '../../app/reducer/auth.reducer';

function getBaseLog(x: number, y: number):number {
  return Math.log(y) / Math.log(x);
}
let options = { year: 'numeric', month: 'long', day: 'numeric' };

export default function Page2() {
  
  const [openErrAlert, setOpenErrAlert] = React.useState<boolean>(false);

  const projectDetails = useAppSelector(getProjectDetails)||{};
  const fanDetails = useAppSelector(getFanDetails);
  const fan = useAppSelector(getFanData);
   const user = useAppSelector(getUser);
  console.log(fanDetails,fan);
  // console.log(fan);
  let projectDate:any;

  if(projectDetails.updatedAt){
    projectDate = new Date(projectDetails.updatedAt+"");
  }else{
    projectDate = new Date();
  }

  const d1 = fanDetails.fan_diameter?parseFloat(fanDetails.fan_diameter):fan.fanDiameter;
  console.log((d1 + (d1 *0.0045* 2)));
  const d2 =fanDetails.fan_ring_diameter?fanDetails.fan_ring_diameter:(d1 + (d1 *0.0045* 2)).toFixed(3); 
  const d4 = fanDetails.blade_no?fanDetails.blade_no:fan.numofBlades;


  const d17 = fanDetails?.air_density?fanDetails?.air_density:((((101325*Math.exp((-9.80665*0.028964*(fanDetails.altitude-0))/(8.31432*((fanDetails.minimum-0)+273)))) - ((6.1078*(10^((7.5*(fanDetails.minimum-0))/((fanDetails.minimum-0)+237.3)))) * (fanDetails.rh-0)))/(287.058*((fanDetails.minimum-0)+273)))+(((6.1078*(10^((7.5*(fanDetails.minimum-0))/((fanDetails.minimum-0)+237.3)))) * (fanDetails.rh-0))/(461.495*((fanDetails.minimum-0)+273))));
  // console.log(d17)
  const d18 = ((((101325*Math.exp((-9.80665*0.028964*(fanDetails.altitude-0))/(8.31432*((fanDetails.minimum-0)+273)))) - ((6.1078*(10^((7.5*(fanDetails.minimum-0))/((fanDetails.minimum-0)+237.3)))) * (fanDetails.rh-0)))/(287.058*((fanDetails.minimum-0)+273)))+(((6.1078*(10^((7.5*(fanDetails.minimum-0))/((fanDetails.minimum-0)+237.3)))) * (fanDetails.rh-0))/(461.495*((fanDetails.minimum-0)+273))));
  const d19 = ((((101325*Math.exp((-9.80665*0.028964*(fanDetails.altitude-0))/(8.31432*((fanDetails.maximum-0)+273)))) - ((6.1078*(10^((7.5*(fanDetails.maximum-0))/((fanDetails.maximum-0)+237.3)))) * (fanDetails.rh-0)))/(287.058*((fanDetails.maximum-0)+273)))+(((6.1078*(10^((7.5*(fanDetails.maximum-0))/((fanDetails.maximum-0)+237.3)))) * (fanDetails.rh-0))/(461.495*((fanDetails.maximum-0)+273))));

  const d28 = fanDetails.beam_no;

  const d31 = 3.14 * (Math.pow(fanDetails.fan_ring_diameter, 2) - Math.pow(fan.hub.hubDiameter, 2))/4;

  const d32 = fanDetails.motor_eff;
  const d33 = fanDetails.transmission_efficiency;

  const d34 = fanDetails.req_airflow
  let d35:any = null;
  let d38:any = null;

  const d46 = d34/d31;

  const d36 = 0.5 * d17 * Math.pow(d46, 2);
  const d37 = d36 - (0.5 * d17 * ( Math.pow(d34/(3.14 * (Math.pow(d2, 2) - Math.pow(fan.hub.hubDiameter, 2)) / 4),2)));
  console.log(d36,d17,d34,fanDetails.discharge_dia,fanDetails.diffuser_eff,d37)
  if(fanDetails.pressure_type==="static"){
    d35 = fanDetails.pressure;
    d38 = (Number(fanDetails.pressure) + Number(d36) - Number(d37));
    console.log(fanDetails.pressure,d36,d37)
  }else{
    d38 = fanDetails.pressure;
    d35 = (fanDetails.pressure - d37);
  }

  const d45 = fan.designPoint?.expectedEfficiency;
  console.log(d34,d38,d45,d35);
  const d39 = d34 * d38 * 0.1 / d45;
  const d42 =((5.192*(d38/(9.807*25.4))*(((22/7)/4)*(Math.pow((d1/0.3048),2)))/2.202)) ;



  const d49 = fanDetails.fan_rpm?fanDetails.fan_rpm:fan.rpm ;

  const d41 =(4500*((d39/0.745)/(2*3.14*d49)));

  const d53 = (d4 * fan.bladeModel.bladeWeight) + fan.hub.hubWeight ;






  const d62 = fan.bladeModel.bladeFreqMode2 ;


  console.log(d1,d49,d39,fanDetails.sound_power_cf,d2)
  console.log(getBaseLog(10,((3.14*d1*d49/0.3048)/1000)),getBaseLog(10,(d39/0.75)),getBaseLog(10,(d1/0.3048)) )
  const d72 = 55+30*getBaseLog(10,((3.14*d1*d49/0.3048)/1000))+10*getBaseLog(10,(d39/0.75))-5*getBaseLog(10,(d1/0.3048))+ parseInt(fanDetails.sound_power_cf)  ;
  const d73 = (d72-2-10*getBaseLog(10,(2*3.14*Math.pow(((d2/2)+1),3)))-(2-6.8*(1-Math.sqrt(1/((d2/2)+1))))) ;
  const d74 = (d72-2-10*getBaseLog(10,((3.14*d2*d2)+(3.14*d2)))-(2-6.8*(1-(Math.sqrt(Math.cos(45)))))) ;
  // console.log(d2, 10*getBaseLog(10,((3.14*d2*d2)+(3.14*d2))),(2-6.8*(1-(Math.sqrt(Math.cos(45))))))

  return (
      <Paper className="datasheet-paper" id="datasheet-page2" style={{width:'100%', padding:'20px'}}>
        <div className="datasheet-row dark-gray">
          <Typography variant="h5" style={{fontSize:'23px', flex:1, textAlign:'center'}}>
            ACCOUSTIC DATA
          </Typography>
        </div>
        <hr/>


        <div className="datasheet-row light-gray">
          <Grid container spacing={3}>
            <Grid item xs={6} lg={6}>
              <div className="data-field">
                <div style={{fontSize:'23px', flex:1, fontWeight:600}}>
                  Project Name:
                </div>
                <div style={{ fontSize:'23px'}}>
                  {projectDetails.project}
                </div>
              </div>
              <div className="data-field">
                <div style={{fontSize:'23px', flex:1, fontWeight:600}}>
                  Customer:
                </div>
                <div style={{ fontSize:'23px'}}>
                  {projectDetails.consultant}
                </div>
              </div>
              <div className="data-field">
                <div style={{fontSize:'23px', flex:1, fontWeight:600}}>
                  Location:
                </div>
                <div style={{ fontSize:'23px'}}>
                  {projectDetails.location}
                </div>
              </div>
            </Grid>
            <Grid item xs={6} lg={6}>
              <div className="data-field">
                <div style={{fontSize:'23px', flex:'1 1 60%', fontWeight:600}}>
                  Date:
                </div>
                <div style={{fontSize:'23px', flex:'1 1 40%',textAlign:'end'}}>
                  {projectDate.toLocaleDateString("en-US", options)}
                </div>
              </div>
              <div className="data-field">
                <div style={{fontSize:'23px', flex:'1 1 60%', fontWeight:600}}>
                  PO/SO No:
                </div>
                <div style={{fontSize:'23px', flex:'1 1 40%',textAlign:'end'}}>
                  {projectDetails.po_number}
                </div>
              </div>
              <div className="data-field">
                <div style={{fontSize:'23px', flex:'1 1 60%', fontWeight:600}}>
                  Project Reference No:
                </div>
                <div style={{fontSize:'23px', flex:'1 1 40%',textAlign:'end'}}>
                  {projectDetails.project_number}
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
        <br/>
        <div className="datasheet-row">
          <Grid container spacing={3}>
            <Grid item xs={6} lg={6}>
              <div className="data-field" style={{marginBottom:'20px'}}>
                <div style={{fontSize:'23px', flex:1}}>
                  Fan Sound Power Level:
                </div>
                <div style={{fontSize:'23px'}}>
                  {d72.toFixed(3)}&nbsp;dB(A)
                </div>
              </div>
              <div className="data-field" style={{marginBottom:'20px'}}>
                <div style={{fontSize:'23px', flex:1}}>
                  Sound Pressure Level:
                  <div style={{marginTop:'-5px', zoom: 0.8}}>(1 Meter Beside Outlet)</div>
                </div>
                <div style={{fontSize:'23px'}}>
                  {d73.toFixed(3)}&nbsp;dB(A)
                </div>
              </div>
              <div className="data-field" style={{marginBottom:'20px'}}>
                <div style={{fontSize:'23px', flex:1}}>
                  Sound Pressure Level:
                  <div style={{marginTop:'-5px', zoom: 0.8}}>(1 Meter Above at 45°)</div>
                </div>
                <div style={{fontSize:'23px'}}>
                  {d74.toFixed(3)}&nbsp;dB(A)
                </div>
              </div>
                 {(user?.user?.userType==1 || user?.user?.userType==2) &&
           <>
              <div className="data-field">
                <div className="datasheet-row datasheet-table" style={{marginTop:'10px', zoom:0.86}}>
                  <Grid container spacing={0} style={{width:'100%'}}>
                    <Grid item>
                        <div className="data-field" style={{fontSize:'23px', flex:1, fontWeight:600}}>
                          Octave
                        </div>
                        <div className="data-field" style={{fontSize:'23px', flex:1, fontWeight:600}}>
                          SPL
                        </div>
                    </Grid>
                    <Grid item>
                        <div className="data-field" style={{fontSize:'23px', flex:1, fontWeight:600}}>
                          Hz
                        </div>
                        <div className="data-field" style={{fontSize:'23px', flex:1, fontWeight:600}}>
                          db(A)
                        </div>
                    </Grid>

                    <Grid item>
                        <div className="data-field" style={{fontSize:'23px', flex:1, fontWeight:600}}>
                          31.5
                        </div>
                        <div className="data-field" style={{fontSize:'23px', flex:1}}>
                          {fan.octaveBand.dB[0]}
                        </div>
                    </Grid>

                    <Grid item>
                        <div className="data-field" style={{fontSize:'23px', flex:1, fontWeight:600}}>
                          63
                        </div>
                        <div className="data-field" style={{fontSize:'23px', flex:1}}>
                          {fan.octaveBand.dB[1]}
                        </div>
                    </Grid>

                    <Grid item>
                        <div className="data-field" style={{fontSize:'23px', flex:1, fontWeight:600}}>
                          125
                        </div>
                        <div className="data-field" style={{fontSize:'23px', flex:1}}>
                          {fan.octaveBand.dB[2]}
                        </div>
                    </Grid>

                    <Grid item>
                        <div className="data-field" style={{fontSize:'23px', flex:1, fontWeight:600}}>
                          250
                        </div>
                        <div className="data-field" style={{fontSize:'23px', flex:1}}>
                          {fan.octaveBand.dB[3]}
                        </div>
                    </Grid>

                    <Grid item>
                        <div className="data-field" style={{fontSize:'23px', flex:1, fontWeight:600}}>
                          500
                        </div>
                        <div className="data-field" style={{fontSize:'23px', flex:1}}>
                          {fan.octaveBand.dB[4]}
                        </div>
                    </Grid>

                    <Grid item>
                        <div className="data-field" style={{fontSize:'23px', flex:1, fontWeight:600}}>
                          1k
                        </div>
                        <div className="data-field" style={{fontSize:'23px', flex:1}}>
                          {fan.octaveBand.dB[5]}
                        </div>
                    </Grid>

                    <Grid item>
                        <div className="data-field" style={{fontSize:'23px', flex:1, fontWeight:600}}>
                          2k
                        </div>
                        <div className="data-field" style={{fontSize:'23px', flex:1}}>
                          {fan.octaveBand.dB[6]}
                        </div>
                    </Grid>

                    <Grid item>
                        <div className="data-field" style={{fontSize:'23px', flex:1, fontWeight:600}}>
                          4k
                        </div>
                        <div className="data-field" style={{fontSize:'23px', flex:1}}>
                          {fan.octaveBand.dB[7]}
                        </div>
                    </Grid>

                    <Grid item>
                        <div className="data-field" style={{fontSize:'23px', flex:1, fontWeight:600}}>
                          8k
                        </div>
                        <div className="data-field" style={{fontSize:'23px', flex:1}}>
                          {fan.octaveBand.dB[8]}
                        </div>
                    </Grid>

                    <Grid item>
                        <div className="data-field" style={{fontSize:'23px', flex:1, fontWeight:600}}>
                          16k
                        </div>
                        <div className="data-field" style={{fontSize:'23px', flex:1}}>
                          {fan.octaveBand.dB[9]}
                        </div>
                    </Grid>
                  </Grid>
                
                </div>                
              </div>
                </>}
            </Grid>
              {(user?.user?.userType==1 || user?.user?.userType==2) &&
           <>
            <Grid item xs={12} lg={12}>
              <OctaveBand setIndex={()=>{return;}} data={fan.octaveBand} onlyGraph={true}/>
            </Grid>
            </>}
          </Grid>
        </div>
        <br/>
        <br/>
        
        <div className="datasheet-row dark-gray" style={{marginTop:'200px'}}>
          <Typography variant="h5" style={{fontSize:'23px', flex:1, textAlign:'center'}}>
            CAMPBELL DIAGRAM
          </Typography>
        </div>
        <hr/>


        <div className="datasheet-row">
          <Grid container spacing={3}>
            <Grid item xs={6} lg={6}>
              <div className="data-field">
                <div style={{fontSize:'23px', flex: '1 1 80%', fontWeight:600}}>
                  Fan Model Number:
                </div>
                <div style={{fontSize:'23px', flex: '1 1 20%',textAlign:'end'}}>
                  {fan.fanModelID}
                </div>
              </div>
              <div className="data-field">
                <div style={{fontSize:'23px', flex:1, fontWeight:600}}>
                  Fan Diameter:
                </div>
                <div style={{fontSize:'23px'}}>
                {d1.toFixed(3)}&nbsp;Mtrs
                </div>
              </div>
              <div className="data-field">
                <div style={{fontSize:'23px', flex:1, fontWeight:600}}>
                  No of Blades:
                </div>
                <div style={{fontSize:'23px'}}>
                  {d4}
                </div>
              </div>
            </Grid>
            <Grid item xs={6} lg={6}>
              <div className="data-field">
                <div style={{fontSize:'23px', flex:1, fontWeight:600}}>
                  Application:
                </div>
                <div style={{fontSize:'23px', textTransform: 'capitalize'}}>
                  {fanDetails.application}
                </div>
              </div>
              <div className="data-field">
                <div style={{fontSize:'23px', flex:1, fontWeight:600}}>
                  Mounting Orientation:
                </div>
                <div style={{fontSize:'23px',textTransform: 'capitalize'}}>
                  {fanDetails.mounting_orientation}
                </div>
              </div>
              <div className="data-field">
                <div style={{fontSize:'23px', flex:1, fontWeight:600}}>
                  Installation Type:
                </div>
                <div style={{fontSize:'23px',textTransform: 'capitalize'}}>
                  {fanDetails.install_type}
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
          <CampbellDiagram setIndex={()=>{return;}} data={fan.octaveBand.rpm} onlyGraph={true}/>
            {/* <div className="datasheet-row dark-gray">
          <Typography variant="h5" style={{fontSize:'23px', flex:1, textAlign:'center'}}>
           TORQUE CURVE
          </Typography>
        </div>
            <TorqueCurve setIndex={()=>{return;}} fanData={fan} fanDetailsInput={fanDetails} onlyGraph={true}/> */}
        <br/>
        <div className="data-footer">
          <hr/>
          <div className="data-field">
            <div style={{fontSize:'23px', flex:'1 1 60%'}}>
              www.encongroup.co.in
            </div>
            <div style={{fontSize:'23px', flex:'1 1 40%',textAlign:'end'}}>
              Page 2 of 5
            </div>
          </div>
            
        </div>

      </Paper>
  );
}
